<div class="perfil-grid" [class.is-disabled]="disabled">
  <div class="d-flex justify-content-between align-items-center mb-2">
    <p class="grid-titulo">
      {{ titulo }}
      @if (tooltip) {
      <mat-icon class="material-symbols-outlined info-icon" [matTooltip]="tooltip" matTooltipPosition="above">info</mat-icon>
      }
    </p>
    <span [matTooltip]="tooltipAdicionar" matTooltipPosition="above">
      <button type="button" mat-button class="btn-section" (click)="adicionar()" [disabled]="!podeAdicionar">
        <mat-icon>add</mat-icon> Adicionar
      </button>
    </span>
  </div>

  @for (item of items; track $index) {
  <div class="perfil-row-wrapper">
    <div class="row w-100 g-2 align-items-center m-0">
      <div class="col-10">
        <mat-form-field appearance="outline" subscriptSizing="dynamic" class="w-100 no-bottom-space compact-input">
          <mat-label>Perfil</mat-label>
          <mat-select [ngModel]="item" (ngModelChange)="onPerfilChange($index, $event)" [disabled]="disabled">
            @for (p of perfisDisponiveis($index); track p.idPerfil) {
            <mat-option [value]="p.idPerfil">{{ p.nome }}</mat-option>
            }
          </mat-select>
        </mat-form-field>
      </div>
      <div class="col-2 delete-col">
        <button type="button" mat-icon-button (click)="remover($index)" [disabled]="disabled" matTooltip="Remover">
          <mat-icon class="material-symbols-outlined">delete</mat-icon>
        </button>
      </div>
    </div>
  </div>
  }

  @if (items.length === 0) {
  <div class="empty-state-bloco">
    <div class="empty-state-titulo">{{ textoVazio }}</div>
    @if (textoVazioApoio) {
    <div class="empty-state-apoio">{{ textoVazioApoio }}</div>
    }
  </div>
  }
</div>
